import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { PumPreview, PumJumpSrpData } from '../../types';
import { SearchResultRepository } from '../search-result-repository';
import type { SearchResultService } from '../search-result-service';

@injectable()
export class SearchResultServiceImpl implements SearchResultService {
    constructor(
        @inject(SearchResultRepository) private searchResultRepository: SearchResultRepository
    ) {
    }

    getPumPreviewParams(data: PumPreview): Promise<PumJumpSrpData> {
        return this.searchResultRepository.preview(data);
    }
}
